import React from "react";
class ContactUs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <div>
                <h2>Contact Us</h2>
                <hr />
                <address>
                    <h5><strong>Engineering Guru</strong></h5>
                </address>
                <address>
                    <a href="mailto:team@engineeringguru.in">team@engineeringguru.in</a>
                </address>
                <address>
                    <h6><strong><a href="https://t.me/joinchat/LaoovEe8ekwoTQPziHLpbQ" target="_blank" rel="noopener noreferrer">Join our Telegram Group</a></strong></h6>
                </address>
                <address>
                    <h6>
                        <strong>
                            <a href="https://www.facebook.com/engineeringguru" target="_blank" rel="noopener noreferrer">Reach via Facebook</a> /
                            <a href="https://www.instagram.com/engineering__guru_" target="_blank" rel="noopener noreferrer"> Instagram</a>
                        </strong></h6>
                </address>
            </div>
        );
    }
}

ContactUs.propTypes = {};

export default ContactUs;
